<script setup>
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const goToIndex = () => {
  router.push({
    name: 'arrows_ai_assistants_index',
    params: { accountId: route.params.accountId },
  });
};
</script>

<template>
  <div class="rounded-xl border border-n-weak bg-n-solid-1 p-6">
    <p class="text-sm text-n-slate-11">
      {{ t('ARROWS_AI.ASSISTANTS.MISSING') }}
    </p>
    <Button
      class="mt-4"
      size="sm"
      :label="t('ARROWS_AI.ASSISTANTS.BACK')"
      @click="goToIndex"
    />
  </div>
</template>
